import { useLocalObservable } from 'mobx-react-lite';

import Tasks from 'APP/Tasks';
import { PayloadType } from 'APP/model/message/messageModel.types';
import Entities from 'STORE';
import { InputPanel } from 'STORE/InputPanelsStore/InputPanel/InputPanel';

interface IVoiceButtonPresenter {
  inputPanel: InputPanel | null;
  isStarted: boolean;
  onStart(): void;
}

export const useVoiceButtonPresenter = (): IVoiceButtonPresenter => {
  const presenter = useLocalObservable<IVoiceButtonPresenter>(() => ({
    get inputPanel(): InputPanel | null {
      return Entities.InputPanelsStore.activeInputPanel;
    },

    get isStarted(): boolean {
      return !!presenter.inputPanel?.voice?.isStarted;
    },

    async onStart(): Promise<void> {
      if (!presenter.inputPanel) {
        return;
      }

      const canStart = Tasks.group.checkSendMessagePermissions({
        groupId: Entities.GroupsStore.activeGroupId!,
        payload: { payloadType: PayloadType.VoiceMessage },
      });

      if (!canStart.result) {
        canStart.error && Entities.toast.show(canStart.error);
        return;
      }

      const startResult = await presenter.inputPanel.voice.start();
      if (!startResult.result) {
        startResult.error && Tasks.app.showAlert(startResult.error);
      }
    },
  }));

  return presenter;
};
